import { render } from "./AdminPlaces.vue?vue&type=template&id=39de7a36&scoped=true"
import script from "./AdminPlaces.vue?vue&type=script&lang=js"
export * from "./AdminPlaces.vue?vue&type=script&lang=js"

import "./AdminPlaces.vue?vue&type=style&index=0&id=39de7a36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39de7a36"]])

export default __exports__